import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/Card';
import { BookOpen, Target } from 'lucide-react';
import type { TutorAnalyticsSummary } from '../../../tutor/types/tutorAnalytics';

interface TutorLastPracticedProps {
  data: TutorAnalyticsSummary;
}

export const TutorLastPracticed: React.FC<TutorLastPracticedProps> = ({ data }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-app-text dark:text-white flex items-center gap-2">
          <BookOpen className="w-5 h-5" />
          Last Practiced Section
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 text-app-text-secondary dark:text-gray-400">
              <Target className="w-4 h-4" />
              <span className="font-medium">Lesson:</span>
            </div>
            <span className="text-lg font-semibold text-app-text dark:text-white">
              {data.last_lesson_no !== null ? `Lesson ${data.last_lesson_no}` : '—'}
            </span>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex items-center gap-2 text-app-text-secondary dark:text-gray-400">
              <BookOpen className="w-4 h-4" />
              <span className="font-medium">Topic:</span>
            </div>
            <span className="text-lg font-semibold text-app-text dark:text-white">
              {data.last_topic_label || '—'}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};